import { LoadingOutlined } from '@ant-design/icons';
import { Flex, Spin } from 'antd';

const Loader = ({ styles = {}, loaderSize = 60, color = 'var(--ant-color-primary)' }) => {
  const customIcon = <LoadingOutlined style={{ fontSize: loaderSize, color }} spin />;

  return (
    <Flex justify="center" align="center" style={styles}>
      <Spin indicator={customIcon} />
    </Flex>
  );
};

export default Loader;
